import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Block = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>{"E5FC1661-0062-4538-A59C-795ED1C1A16B@1x"}</title>
      <defs>
        <path
          d="M12 4a8 8 0 110 16 8 8 0 010-16zm5.162 3.78l-9.381 9.382a6.667 6.667 0 009.381-9.381zM12 5.334A6.667 6.667 0 006.838 16.22l9.381-9.381A6.64 6.64 0 0012 5.333z"
          id="block-line-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="block-line-b" fill="#fff">
          <use xlinkHref="#block-line-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#block-line-a" />
        <g
          mask="url(#block-line-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>{"73F8919E-DCF0-46B0-91E5-8B9DFEF25FE1@1x"}</title>
      <defs>
        <path
          d="M12 4a8 8 0 100 16 8 8 0 000-16zm-5.333 8A5.34 5.34 0 0112 6.667c.987 0 1.91.274 2.704.744l-7.293 7.293A5.297 5.297 0 016.667 12zM12 17.333c-.987 0-1.91-.274-2.704-.744l7.293-7.293c.47.794.744 1.717.744 2.704A5.34 5.34 0 0112 17.333z"
          id="block-solid-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="block-solid-b" fill="#fff">
          <use xlinkHref="#block-solid-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#block-solid-a" />
        <g
          mask="url(#block-solid-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
